// Memoria local de la publicidad: qué campañas ya se mostraron o cerró cada usuario
// en esta computadora. A diferencia de las ayudas ("<vista>.ayudaOculta"), la clave
// lleva comercio y usuario porque las PC de kiosco se comparten entre cajeros.
// El servidor también filtra por eventos; esta memoria evita que una campaña recién
// cerrada vuelva a aparecer antes del próximo inicio de sesión.

export const CLAVE_BASE = "publicidad";
export const FRECUENCIAS = Object.freeze({
  UNA_VEZ_USUARIO: "una_vez_usuario",
  UNA_VEZ_DIA: "una_vez_dia",
  SIEMPRE: "siempre",
});

const memoriaVacia = () => ({ mostradas: {}, noMostrar: [] });

function storagePorDefecto() {
  return typeof localStorage !== "undefined" ? localStorage : null;
}

export function claveDe({ empresaCliente, idUsuario }) {
  return `${CLAVE_BASE}.${empresaCliente}.${idUsuario}`;
}

/** Comercio y usuario del objeto `token` que guarda el login. */
export function identidadDesdeStorage(storage = storagePorDefecto()) {
  try {
    const token = JSON.parse(storage.getItem("token"));
    if (!token || token.id_usuario == null || !token.empresa_cliente) return null;
    return { empresaCliente: token.empresa_cliente, idUsuario: token.id_usuario };
  } catch (error) {
    return null;
  }
}

export function leerMemoria(identidad, storage = storagePorDefecto()) {
  try {
    const guardada = JSON.parse(storage.getItem(claveDe(identidad)));
    if (!guardada || typeof guardada !== "object") return memoriaVacia();
    return {
      mostradas: guardada.mostradas && typeof guardada.mostradas === "object" ? guardada.mostradas : {},
      noMostrar: Array.isArray(guardada.noMostrar) ? guardada.noMostrar : [],
    };
  } catch (error) {
    return memoriaVacia();
  }
}

function guardarMemoria(identidad, memoria, storage) {
  try {
    storage.setItem(claveDe(identidad), JSON.stringify(memoria));
  } catch (error) {
    // Una memoria que no se pudo guardar no es un error para el usuario
  }
}

const mismoDia = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

/** Aplica la frecuencia de la campaña contra lo que ya vio este usuario. */
export function estaOculta(campania, memoria, hoy = new Date()) {
  if (memoria.noMostrar.includes(campania.id)) return true;
  const mostrada = memoria.mostradas[campania.id];
  if (campania.frecuencia === FRECUENCIAS.SIEMPRE) return false;
  if (campania.frecuencia === FRECUENCIAS.UNA_VEZ_DIA) {
    return Boolean(mostrada) && mismoDia(new Date(mostrada), hoy);
  }
  return Boolean(mostrada);
}

export function marcarMostrada(identidad, idCampania, storage = storagePorDefecto(), hoy = new Date()) {
  if (!identidad || !storage) return;
  const memoria = leerMemoria(identidad, storage);
  memoria.mostradas[idCampania] = hoy.toISOString();
  guardarMemoria(identidad, memoria, storage);
}

export function marcarNoMostrar(identidad, idCampania, storage = storagePorDefecto()) {
  if (!identidad || !storage) return;
  const memoria = leerMemoria(identidad, storage);
  if (!memoria.noMostrar.includes(idCampania)) memoria.noMostrar.push(idCampania);
  guardarMemoria(identidad, memoria, storage);
}
